import { render, staticRenderFns } from "./RelatedDocumentsMenu.vue?vue&type=template&id=5512d9f3"
import script from "./RelatedDocumentsMenu.vue?vue&type=script&lang=js"
export * from "./RelatedDocumentsMenu.vue?vue&type=script&lang=js"
import style0 from "./RelatedDocumentsMenu.vue?vue&type=style&index=0&id=5512d9f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports